import { Button } from '@mui/material';

const NavigationButton = ({ children, mr = 0, className = '', ...props }) => {
    const size = 35;
    return (
        <Button
            sx={{
                width: size,
                height: size,
                minWidth: size,
                p: 0,
                '&:hover': {
                    opacity: 0.9,
                },
                mr: mr,
            }}
            className={className}
            {...props}
        >
            {children}
        </Button>
    );
};

export default NavigationButton;
